'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlatform = getPlatform;
exports.isAndroid = isAndroid;
exports.isIOS = isIOS;
exports.isQQBrowser = isQQBrowser;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * @Author: edvardchen
 * @Date:   2016-10-10 17:51:05
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-09-23 12:04:43
 */

var platformMap = {
  ADR: /Android/i,
  iOS: /iPhone/i,
  iPad: /iPad/i
};

function getPlatform(userAgent) {
  var platForm = void 0;
  try {
    // 客户端使用 jsapi 检查 UA
    /* global window */
    platForm = window.browser.env.platForm;
  } catch (ignore) {/* disable eslint no-empty */}
  if (platForm) {
    if (platForm === 'I') {
      return 'iOS';
    }
    if (platForm === 'IP') {
      return 'iPad';
    }
    return platForm;
  }

  var result = 'unknown';
  Object.keys(platformMap).some(function (key) {
    var reg = platformMap[key];
    if (reg.test(userAgent)) {
      result = key;
      return true; // break;
    }
    return false;
  });

  return result;
}

function isAndroid(userAgent) {
  return getPlatform(userAgent) === 'ADR';
}

function isIOS(userAgent) {
  return getPlatform(userAgent) === 'iOS';
}

var UAMap = {
  QQ: / QQ\//i,
  Qzone: / Qzone\//i,
  WeChat: / MicroMessenger\//i,
  QQMusic: / QQMusic\//i,
  QbInfoApp: / QbInfoApp/i,
  TBS: / TBS\//i,
  MiniQB: / MiniQB\//i
  // QQBrowser: / MQQBrowser\//i,
};

Object.keys(UAMap).forEach(function (key) {
  var reg = UAMap[key];
  Object.assign(exports, _defineProperty({}, 'is' + key, function undefined(userAgent) {
    return reg.test(userAgent);
  }));
});

var regQB = / MQQBrowser\//i;
var iOSSdk = / QBWebViewType\//i;
function isQQBrowser(userAgent) {
  return !exports.isTBS(userAgent) && (regQB.test(userAgent) || iOSSdk.test(userAgent) && !exports.isQQ(userAgent) // iOS在某些版本会丢失 MQQBrowser
  );
}